import React, { startTransition } from "react";
import { icons } from "assets";
import SettingsCard from "Components/shared/cards/SettingsCard";
import Text from "Components/shared/text";
import { useNavigate } from "react-router-dom";

import styles from './transfer.module.css';



const TransferHome = () => {
    const navigate = useNavigate()
    
    return (
        <div className={styles.Home}>
            <Text variant="md2" style={{fontWeight:700}}>What do you want to do?</Text>
            <div className={styles.SettingCards}>
                <SettingsCard icon={<img src={icons.saved_beneficiary} alt="saved beneficiary" />} 
                    text="Transfer money to saved beneficiary" action = {() =>startTransition(() =>navigate("beneficiary") ) }/>
                <SettingsCard icon={<img src={icons.user_add} alt="add new user" />}
                text="Add new beneficiary " action = {() => startTransition(() => navigate("new-account")) }/>
                <SettingsCard icon={<img src={icons.acc1} alt="add new user" />}
                text="View all beneficiaries " action = {() => startTransition(() => navigate("view-beneficiary")) }/>
                <SettingsCard icon={<img src={icons.transfer_history} alt="transfer history" />}
                text="View your transfer transaction " action = {() =>startTransition(() =>navigate("transfer-history")) }/>
             </div>
        </div>
    )
}

export default TransferHome